import useMeasure from 'use-measure';
import styled from '@emotion/styled';
import React, { memo, useRef } from 'react';
import { useMedia } from 'react-use-media';

import colours from '~/utils/colours';

const StepHeading = styled.h4`
  color: ${colours.greyMediumDark};
  text-transform: uppercase;
`;

interface StepContainerProps {
  isLimitedHeight?: boolean;
}

const StepContainer = styled.div<StepContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 15px;

  padding-bottom: ${(props) => (props.isLimitedHeight ? '100px' : '0')};
`;

interface StepProps {
  heading?: string;
  children: React.ReactNode;
}

const Step = React.forwardRef(({ heading, children }: StepProps, ref) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  function attachRef(el: HTMLDivElement | null) {
    containerRef.current = el;

    if (typeof ref === 'function') {
      ref(el);
    } else if (ref) {
      ref.current = el;
    }
  }

  const { height: windowHeight } = useMeasure({ current: document.body });
  const { height } = useMeasure(containerRef);

  const isHeightLimitReached = useMedia({
    maxHeight: 600,
  });

  return (
    <StepContainer
      style={{ minHeight: Math.max(height, windowHeight / 2) }}
      ref={attachRef}
      isLimitedHeight={isHeightLimitReached}
    >
      {heading && <StepHeading>{heading}</StepHeading>}
      {children}
    </StepContainer>
  );
});

export default memo(Step);
